"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadWorldPartyCharacterUpdate = void 0;
const WorldCharacter_1 = require("../../classes/WorldCharacter");
const definables_1 = require("definables");
const updateWorldCharacterOrder_1 = require("../updateWorldCharacterOrder");
const loadWorldPartyCharacterUpdate = (worldPartyCharacterUpdate) => {
    var _a, _b, _c, _d;
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldPartyCharacterUpdate.characterID);
    const questInstances = {};
    if (typeof worldPartyCharacterUpdate.questInstances !== "undefined") {
        for (const questID in worldPartyCharacterUpdate.questInstances) {
            const questInstance = worldPartyCharacterUpdate.questInstances[questID];
            if (typeof questInstance === "undefined") {
                throw new Error("No quest instance.");
            }
            questInstances[questID] = {
                isCompleted: (_a = questInstance.isCompleted) !== null && _a !== void 0 ? _a : false,
                isStarted: (_b = questInstance.isStarted) !== null && _b !== void 0 ? _b : false,
                monsterKills: questInstance.monsterKills,
            };
        }
    }
    worldCharacter.isRenewing = worldPartyCharacterUpdate.isRenewing;
    worldCharacter.openedChestIDs = worldPartyCharacterUpdate.openedChestIDs;
    worldCharacter.resources = {
        hp: worldPartyCharacterUpdate.resources.hp,
        maxHP: worldPartyCharacterUpdate.resources.maxHP,
        maxMP: (_c = worldPartyCharacterUpdate.resources.maxMP) !== null && _c !== void 0 ? _c : null,
        mp: (_d = worldPartyCharacterUpdate.resources.mp) !== null && _d !== void 0 ? _d : null,
    };
    (0, updateWorldCharacterOrder_1.updateWorldCharacterOrder)(worldCharacter.id, worldPartyCharacterUpdate.order);
};
exports.loadWorldPartyCharacterUpdate = loadWorldPartyCharacterUpdate;
